
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/panels/widgetPanels/slotSelectionExtendedPanel/slotPlaceholderItem.scss.css.virtualfile';
        module.exports = {"slotPlaceholderItem":"_slotPlaceholderItem_au5nj_1","slotPlaceholderItemTooltip":"_slotPlaceholderItemTooltip_au5nj_5"};